import axios from '../axios';

class Api {
    static getListAfdeling (withselect, bedrijf, zoekstring) {
        return axios.get(`/afdeling/list?bedrijf=${bedrijf}&zoekstring=${zoekstring}&withselect=${withselect}`);
    }

    static getDetailAfdeling (id) {
        return axios.get(`/afdeling/detail/${id}`);
    }

    static getBelichtingsuren (id) {
        return axios.get(`/afdeling/belichtingsuren/${id}`);
    }

    static addAfdeling (payload) {
        return axios.post('/afdeling', payload);
    }

    static updateAfdeling (payload) {
        return axios.post(`/afdeling/update/${payload.id}`, payload);
    }

    static deleteAfdeling (payload) {
        return axios.post(`/afdeling/delete/${payload}`);
    }

    static kopieerAfdeling (payload) {
        return axios.get(`/afdeling/kopieer/${payload}`);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/afdeling.js